import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationApplicationRate
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectApplicationRate } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    applicationRate?: CalibrationApplicationRate;
}

type Props = OwnProps & ConnectedProps;

export class ApplicationRateTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { applicationRate } = this.props;

        return <TableCell>{applicationRate}L/ha</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    applicationRate: makeSelectApplicationRate()
});

export default connect(mapStateToProps)(ApplicationRateTableCellComponent);
